/**
 * 官网新闻 / 公司动态
 * 按 date 倒序展示。新增一篇：复制一条，改 slug（唯一、英文短横线）、封面、正文即可。
 * 封面建议传到 OSS 后填完整 URL；没有封面会显示分类色块。
 */
export const newsArticles = [
    {
        slug: 'zuyu-app-launch',
        date: '2026-07-20',
        category: '产品动态',
        title: '族语APP 正式上线 iOS、Android、HarmonyOS',
        summary: '族语已登陆三大平台。围绕家庭记忆与亲情连接，帮助每个家庭把成长、人生与日常，收进一份可以长期保存的数字档案。',
        cover: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/annouceImg.png',
        content: [
            '族语APP 现已上线 App Store、安卓应用市场与华为应用市场，覆盖 iOS、Android、HarmonyOS 三大平台。',
            '它不同于普通社交软件，也不同于单纯的云存储：族语围绕「家庭」这一长期关系来设计，帮助用户记录家庭成员关系、孩子成长、人生故事，以及那些容易被忽略的日常瞬间。',
            '我们希望解决一个很朴素的问题——如何让一个家庭的故事被保存下来，并能够被下一代继续看见。',
            '即日起，可在官网下载页选择对应系统，开始为家人建立一份属于自己的数字记忆馆。',
        ],
    },
    {
        slug: 'team-basketball-day',
        date: '2026-08-16',
        category: '团队活动',
        title: '球场上见：族迹篮球活动纪实',
        summary: '周末一场内部篮球活动，把写代码、做产品、做运营的同事聚到同一块场地上。跑动、传球、加油，比任何团建 PPT 都更直接。',
        cover: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=1600&q=80',
        photos: [
            'https://oss.sayfamily.com/news/sport/44f0da61f2b2060c8e9776a876759a33.jpg',
            'https://oss.sayfamily.com/news/sport/b25eace2b0588068858c8f861ac23627.jpg',
            'https://oss.sayfamily.com/news/sport/ddbe1b8365843286e69c164211d2f05d.jpg',
        ],
        content: [
            '技术公司的日常很容易变成「人对着屏幕」。这场篮球活动，是想让大家从工位上站起来，在球场上重新认识彼此。',
            '当天没有复杂流程：分组、热身、开打。有人投篮很稳，有人负责满场飞奔，场边则是一声接一声的加油。比分会变，气氛一直在。',
            '下工位之后，协作其实还在继续——传球要默契，防守要补位，和做产品时的配合是同一件事。',
            '这类活动我们会不定期举办。现场照片如下，后续花絮也会继续更新在这篇动态里。',
        ],
    },
    {
        slug: 'why-we-build-zuyu',
        date: '2026-06-08',
        category: '公司动态',
        title: '我们为什么做族语：让家的故事有处可寻',
        summary: '数字时代记录越来越多，留下的却未必更多。族语希望给每个家庭一个长期的数字空间，把成长、亲情与人生重新连接起来。',
        cover: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/backgroundImage.png',
        content: [
            '孩子成长的点滴散落在手机相册里，父母的人生故事停在记忆中，家人的瞬间随着时间被遗忘。我们记录了很多，却缺少一个真正属于家庭的地方。',
            '江西族迹希望用数字技术连接亲情：记录孩子成长、整理长辈人生、连接家庭成员、沉淀家族故事，让每一次记录都成为未来回望时的一份陪伴。',
            '这不是又做一个社交产品，而是一套可以长期守护家庭记忆的服务。隐私由家人自主掌控，技术服务于温度，而不是相反。',
            '我们相信，每一个家庭都值得拥有一份不会消失的记忆。守护家庭记忆，延续血脉亲情，让家的故事世代相传。',
        ],
    },
];

export const newsCategoryStyle = {
    '产品动态': 'bg-blue-100 text-blue-700',
    '公司动态': 'bg-emerald-100 text-emerald-700',
    '团队活动': 'bg-orange-100 text-orange-700',
    '媒体报道': 'bg-purple-100 text-purple-700',
};

export const getSortedNews = () =>
    [...newsArticles].sort((a, b) => new Date(b.date) - new Date(a.date));

export const getNewsBySlug = (slug) =>
    newsArticles.find((item) => item.slug === slug);

export const formatNewsDate = (dateStr) => {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return { day: '--', month: '----', full: dateStr || '' };
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return {
        day,
        month: `${y}.${m}`,
        full: `${y}年${m}月${day}日`,
    };
};
